import { ServicePlugin } from '../ServicePlugin';
import { AssignStudyTemplateServicePlugin } from './assignStudyTemplate.service';
import { QualificationServicePlugin } from './qualification.service';
import { QuitStudyParticipantServicePlugin } from './quitStudyParticipant.service';

/**
 * Default service plugins registered with the form state machine. Populated as
 * form-element plugins migrate off the `useEffect + ref + emitEvent('final')`
 * workaround onto state-machine `invoke` services (CD-207).
 */
export const defaultServicePlugins: ServicePlugin[] = [
  AssignStudyTemplateServicePlugin,
  QualificationServicePlugin,
  QuitStudyParticipantServicePlugin
];
